import script from "./productSwiperImageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./productSwiperImageDialog.vue?vue&type=script&setup=true&lang=js"

import "./productSwiperImageDialog.vue?vue&type=style&index=0&id=0ef8de1e&lang=css"

const __exports__ = script;

export default __exports__